import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { ButtonBase } from '../modus-button-base';

/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */

export type StrokedButtonColor = 'primary' | 'secondary';

@Component({
  selector: 'button[modus-stroked-button]',
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModusStrokedButton extends ButtonBase {
  private _color: StrokedButtonColor = 'primary';

  private colorClasses = {
    primary: 'modus-stroked-button-primary',
    secondary: 'modus-stroked-button-secondary',
  };

  @Input() set color(value: StrokedButtonColor) {
    const oldColor = this.colorClasses[this._color];
    const newColor = this.colorClasses[value];

    if (oldColor) this.element.classList.remove(oldColor);
    this.element.classList.add(newColor);

    this._color = value;
  }

  constructor(elementRef: ElementRef) {
    super(elementRef);
    this.element.classList.add('modus-stroked-button-primary');
  }
}
